import type { FeatureFlipperOptionRequirementsType } from "./types";

export const featureFlipperOptionRequirements: FeatureFlipperOptionRequirementsType = {
  SMS_PROPERTIES: "sms_inbound_response_handling",
  WHATS_APP_PROPERTIES: "native_whatsapp",
  B2B: "b2b_mvp",
  DATA_OBJECTS: "b2b_ea",
};
